import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import {
    FileSystemService,
  Template,
  TemplateService,
  TemplateType,
  TemplateTypeService } from "../../../../swaggerServices";
import { TemplateUploadOutput } from "../../../../swaggerServices/model/templateUploadOutput";
import { Subscription } from "rxjs";
import { TaxYearsService } from "../../../shared/util/tax-years.service";
import { ConfigStateService } from "../../config/config-state.service";
import { UntypedFormControl, UntypedFormGroup } from "@angular/forms";
import { DropdownListOption } from "../../../shared/components/search-dropdown/search-dropdown.component";
import { ActivatedRoute } from "@angular/router";
import moment from "moment";
import { ClientNotificationService } from "../../client-notification.service";
import { environment } from '../../../environments/environment';
import { TenantConfigService } from "../../../shared/services/tenant-config.service";
import { TranslocoService} from "@jsverse/transloco";
import { UpdateTemplateTypeComponent } from "./update-template-type/update-template-type.component";

const DATE_FORMAT = "YYYY-MM-DD";
const DISPLAY_DATE_FORMAT = "DD/MM/YYYY HH:mm";

declare var $: any;

interface ITemplateUploadOutput extends TemplateUploadOutput {
  error?: { message?: string };
}
interface ITemplate extends Template {
  type?: string;
}

interface ITemplateType extends TemplateType {
  displayUpdatedAt?: string;
  displayCreatedAt?: string;
  selected?: boolean;
}

@Component({
    selector: "app-templates",
    templateUrl: "./templates.component.html",
    styleUrls: ["./templates.component.scss"],
    standalone: false
})
export class TemplatesComponent implements OnInit, OnDestroy {
  isLoading: boolean;

  bulkAddTemplate?: ITemplateUploadOutput;
  templateTypeId: number;
  type: string;
  sourceFile: File;
  uiConfig: TenantConfigService;
  yearLabel: string;

  templates: ITemplate[];
  templateTypeByYear: Template[];
  templatesByYearByType: Template[];
  templateTypesForConfigExport: ITemplateType[];
  templateTypeFilter: any;
  templateSearch: string;
  templatesByYear: {} = {};
  configExportDate = '';
  selectedTemplateTypes = [];

  moduleMap: Map<string, string> = new Map();
  groupMap: Map<string, string> = new Map();

  @ViewChild("dropDown")
  dropDown: ElementRef;
  // @ViewChild('typeDropDown', {static: false}) typeDropDown: ElementRef;
  @ViewChild("templateUploadModal")
  templateUploadModal: ElementRef;
  @ViewChild("templateViewModal")
  templateViewModal: ElementRef;
  @ViewChild("msgModal")
  msgModal: ElementRef;
  @ViewChild("multiSelectDropdown")
  multiSelectDropdown: ElementRef;
  @ViewChild("uploadFile")
  uploadFile: ElementRef;
  @ViewChild("configExportConfimationModal")
  configExportConfimationModal: ElementRef;

  searchForm: UntypedFormGroup = new UntypedFormGroup({});
  taxYear: UntypedFormControl;
  taxYearOptions: DropdownListOption[];
  subscriptions: Subscription[] = [];

  showTypeDropdown = false;
  typeList = [];

  configExportMode = false;
  showYearError = false;
  entireListSelected = false;
  isProductionMode: boolean;

  constructor(
    private templateService: TemplateService,
    private templateTypeService: TemplateTypeService,
    private activatedRoute: ActivatedRoute,
    private taxYearsService: TaxYearsService,
    private clientNotificationService: ClientNotificationService,
    public config: ConfigStateService,
    private translocoService: TranslocoService,
    private fileSystemService: FileSystemService,
    private dialog: MatDialog,
  ) {
    this.isProductionMode = environment.production;
  }

  ngOnInit() {
    setTimeout(() =>
      $(".multi-select.dropdown").dropdown({
        placeholder: "All",
        preserveHTML: false,
      })
    );

    this.subscriptions.push(
      this.taxYearsService.getTaxYears().subscribe((years: any) => {
        this.taxYearOptions = years;
        const taxYr = this.activatedRoute.snapshot.queryParams.taxYear || this.taxYearsService.getCurrentTaxYear();
        this.taxYear = new UntypedFormControl(taxYr);
        this.searchForm = new UntypedFormGroup({});
        this.searchForm.addControl("taxYear", this.taxYear);
        this.subscriptions.push(
          this.taxYear.valueChanges.subscribe((val: DropdownListOption) => {
            this.getTemplateTypeByYear(this.taxYear.value.value);
          })
        );
      })
    );
    this.subscriptions.push(
      this.config.loadConfig().subscribe(config => {
        this.uiConfig = new TenantConfigService(config);
        this.yearLabel = this.uiConfig.config.yearLabel;
        this.translocoService.selectTranslate('year').subscribe(value => this.yearLabel = value);

        this.moduleMap.set("TAXRETURN", this.uiConfig.config.taxReturnAlias.replace(/\s/g, "").toUpperCase());
        this.moduleMap.set("NOTICE", "NOTICE");
        this.moduleMap.set("OTHER", "OTHER");

        this.groupMap.set("taxreturn", this.uiConfig.config.taxReturnAlias.replace(/\s/g, "").toLowerCase());
        this.groupMap.set("batch", "Batch");
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  selectType(type: TemplateType) {
    this.templateTypeId = type.id;
    this.type = type.templateType;
  }

  hideTypeDropdown() {
    this.showTypeDropdown = false;
  }

  initTypeDropdown(filterType: string = "") {
    this.templateTypeService.getTemplateTypes().subscribe((t: any) => {
      this.typeList = t.filter((tt: any) => {
        if (!filterType || tt.templateType.toLowerCase().includes(filterType.toLowerCase())) {
          return tt;
        }
      });
    });
  }

  openTemplateViewModal(templateType: string, year: number) {
    this.getTemplateTypeByYearByType(templateType, year);
    $(this.templateViewModal.nativeElement).modal("show");
  }

  updateTemplateActivity(template) {
    if (template.active) {
      return;
    }
    this.templateService
      .updateTemplate({
        id: template.id,
        active: "true",
      })
      .subscribe(() => {
        this.getTemplateTypeByYear(this.taxYear.value.value);
        this.getTemplateTypeByYearByType(template.templateType.templateType, this.taxYear.value.value);
      });
  }

  openTemplateUploadModal() {
    $(this.templateUploadModal.nativeElement).modal("show");
  }

  openConfigExportConfimationModal() {
    this.selectedTemplateTypes = this.templateTypesForConfigExport.map((tt) => {
      if (tt.selected) { return {templateType: tt.templateType, displayUpdatedAt: tt.displayUpdatedAt} }
    }).filter(tt => tt);
    $(this.configExportConfimationModal.nativeElement).modal("show");
  }

  initFile(files: any) {
    this.sourceFile = undefined;
    this.bulkAddTemplate = {};

    const pattern = /\.(xlsx|docx|xml|pdf|json)$/i;
    const isValidType = pattern.test(files[0].name);

    if (!isValidType) {
      this.bulkAddTemplate = {
        error: {
          message: "Please upload a file in xlsx, docx, xml or json format.",
        },
      };
      this.clearMessage();
    } else {
      this.sourceFile = files[0];
    }
  }

  uploadTemplate() {
    var splitted = this.sourceFile.name.split(".");
    const fileType = splitted[splitted.length - 1];
    const filename = this.sourceFile.name.slice(0, this.sourceFile.name.length - 1 - fileType.length);

    this.isLoading = true;

    this.templateService
      .bulkAddtemplate(this.sourceFile, this.taxYear.value.value, filename, fileType, this.templateTypeId)
      .subscribe(
        (d: ITemplateUploadOutput) => {
          this.isLoading = false;
          this.getTemplateTypeByYear(this.taxYear.value.value);
          this.bulkAddTemplate = {
            message: filename.concat(" is added as template for ", this.type),
          };
          this.clearMessage();
        },
        err => {
          this.isLoading = false;
          this.bulkAddTemplate = {
            error: {
              message: err.error.message,
            },
          };
          this.clearMessage();
        }
      );
  }

  updateTemplateType(templateType?: TemplateType) {
    this.dialog.open(UpdateTemplateTypeComponent, {
      width: '540px',
      data: templateType || null,
      autoFocus: 'input',
    }).afterClosed().subscribe(updated => {
      if (updated) {
        this.getTemplateTypeByYear(this.taxYear.value.value);
      }
    });
  }

  toggleConfigExportMode() {
    this.configExportMode = !this.configExportMode;
  }

  showTemplatesWithChanges() {
    this.templateTypesForConfigExport = [];
    const date = moment(this.configExportDate, DATE_FORMAT);
    this.templates.forEach((template) => {
      const updatedAt = moment(template.templateType.updatedAt);
      if (updatedAt.isAfter(date)) {
        this.templateTypesForConfigExport.push(template.templateType);
        const createdAt = moment(template.templateType.createdAt);
        this.templateTypesForConfigExport[this.templateTypesForConfigExport.length - 1]
          .displayUpdatedAt = updatedAt.format(DISPLAY_DATE_FORMAT).toString();
        this.templateTypesForConfigExport[this.templateTypesForConfigExport.length - 1]
          .displayCreatedAt = createdAt.format(DISPLAY_DATE_FORMAT).toString();
        this.templateTypesForConfigExport[this.templateTypesForConfigExport.length - 1]
          .selected = false;
      }
    });
  }

  entireListSelection() {
    this.templateTypesForConfigExport.forEach((templateType) => {
      templateType.selected = this.entireListSelected;
    });
  }

  listSelection() {
    this.templateTypesForConfigExport.forEach((t) => {
      if (t.selected === false) return this.entireListSelected = false;
    })
  }

  private loadTemplateTypesForConfigExport() {
    this.showYearError = false;
    if (!this.taxYear.value.value) {
      this.showYearError = true;
      return;
    }
    if (this.configExportDate.length) {
      this.showTemplatesWithChanges();
      return;
    }
    this.templateTypesForConfigExport = [];
    this.templates.forEach((template) => {
      this.templateTypesForConfigExport.push(template.templateType);
      const updatedAt = moment(template.templateType.updatedAt);
      const createdAt = moment(template.templateType.createdAt);
      this.templateTypesForConfigExport[this.templateTypesForConfigExport.length - 1]
        .displayUpdatedAt = updatedAt.format(DISPLAY_DATE_FORMAT).toString();
      this.templateTypesForConfigExport[this.templateTypesForConfigExport.length - 1]
        .displayCreatedAt = createdAt.format(DISPLAY_DATE_FORMAT).toString();
      this.templateTypesForConfigExport[this.templateTypesForConfigExport.length - 1]
        .selected = false;
    });
  }

  downloadConfig() {
    const ids = this.templateTypesForConfigExport.map((tt) => {
      if (tt.selected) { return tt.id; }
    }).filter(x => x);
    this.templateTypeService.downloadConfigExportTemplateType({templateTypeIds: ids}).subscribe(data => {
      if (!data.fileContent)  {
        this.clientNotificationService.appendMessage("File couldn't be fetched, please try again later", "Download config", false);
        return;
      }
      var elem = window.document.createElement('a');
      elem.href = "data:application/json,"+encodeURIComponent(data.fileContent);
      elem.download = data.fileName ? data.fileName : "package";
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
      this.clearSelectedTemplateTypes();
      $(this.configExportConfimationModal.nativeElement).modal("hide");
    }, error => {
      $(this.configExportConfimationModal.nativeElement).modal("hide");
    });
  }

  downloadTemplate(template: string) {
    this.fileSystemService.fileSystemDownloadSingleFilePut({ documentId: template }).subscribe(({ fileContent, fileName }) => {
      const elem = window.document.createElement('a');
      elem.href = `data:application/octet-stream;base64,${fileContent}`;
      elem.download = fileName;
      document.body.appendChild(elem);
      elem.click();
      document.body.removeChild(elem);
    })
  }


  private clearMessage() {
    this.type = "";
    this.uploadFile.nativeElement.value = "";
    $(this.msgModal.nativeElement).modal("show");
  }

  private clearSelectedTemplateTypes() {
    this.templateTypesForConfigExport.forEach(tt => tt.selected = false);
  }

  private getTemplateTypeByYear(year: number) {
    if (!year) return false;

    this.templateService.getTemplates().subscribe((t: any) => {
      this.templates = t;

      this.initTypeDropdown();
      this.templatesByYear[year] = this.templates.filter(function(template) {
        return template.year == year && template.active == true;
      });
      this.templates = this.templatesByYear[year];
      this.templates.forEach(t => (t.type = t.templateType.templateType));
      this.loadTemplateTypesForConfigExport();
    });
  }

  private getTemplateTypeByYearByType(templateType: string, year: number) {
    this.templateService.getTemplates().subscribe((t: any) => {
      this.templatesByYearByType = t.filter(function(template) {
        return template.year == year && template.templateType.templateType == templateType;
      });
      this.templatesByYearByType.map(t => (t.createdAt = moment(t.createdAt).format("DD-MM-YYYY, h:mm:ss a")));
    });
  }
}
